import { useCallback } from "react";
import { useRequest } from "ahooks";
import { Select } from "antd";
import { setting as settingService } from "@/services";

function PublicationSelect({ value, onChange, token }) {
  const { data = { results: [] }, loading } = useRequest(
    () => settingService.listPublication({}, token),
    {
      ready: !!token,
      refreshDeps: [token],
    }
  );

  const changeHandler = useCallback(
    (value) => {
      onChange(value);
    },
    [onChange]
  );

  const optionItems = data.results.map((item) => (
    <Select.Option key={item.id} value={item.id}>
      {item.name}
    </Select.Option>
  ));

  return (
    <Select
      loading={loading}
      value={value}
      allowClear={true}
      onChange={changeHandler}
      placeholder="空"
    >
      {optionItems}
    </Select>
  );
}

export default PublicationSelect;
